import { differenceInDays, parseISO } from 'date-fns'
import { ErrorMessage, Field, Form, defineRule } from 'vee-validate'

export default defineNuxtPlugin((nuxtApp) => {
  defineRule(
    'date_within_range',
    (range: unknown, [days]: string[], { field }) => {
      if (!Array.isArray(range)) {
        return true
      }
      const [start, end] = range as [string, string]
      if (differenceInDays(parseISO(end), parseISO(start)) <= Number(days)) {
        return true
      }

      return `${field}は${days}日以内である必要があります`
    }
  )

  defineRule(
    'date_beyond_range',
    (range: unknown, [days]: string[], { field }) => {
      if (!Array.isArray(range)) {
        return true
      }
      const [start, end] = range as [string, string]
      if (differenceInDays(parseISO(end), parseISO(start)) >= Number(days)) {
        return true
      }

      return `${field}は${days}日以上離れている必要があります`
    }
  )

  nuxtApp.vueApp.component('ValidationForm', Form)
  nuxtApp.vueApp.component('ValidationField', Field)
  nuxtApp.vueApp.component('ValidationErrorMessage', ErrorMessage)
})

// VeeValidateの型定義を拡張
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    ValidationForm: typeof Form
    ValidationField: typeof Field
    ValidationErrorMessage: typeof ErrorMessage
  }
}
